/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SdtPositionDto } from '../../models/sdt-position-dto';

export interface UpdateSdtPosition$Params {
  id: string;
      body: SdtPositionDto
}

export function updateSdtPosition(http: HttpClient, rootUrl: string, params: UpdateSdtPosition$Params, context?: HttpContext): Observable<StrictHttpResponse<SdtPositionDto>> {
  const rb = new RequestBuilder(rootUrl, updateSdtPosition.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SdtPositionDto>;
    })
  );
}

updateSdtPosition.PATH = '/v1/sdtpositions/{id}';
